import React from "react";
import { Text, HStack, VStack, Box, Grid } from "@chakra-ui/react";
import "../../../styles/TutorialPage.css";
import VideoModal from "./VideoPlayer";
import { useTranslation } from "react-i18next";
import LeftArrowInCircle from "assets/images/LeftArrowInCircle.png";
import { useHistory, useLocation } from "react-router-dom";

type LocationState = {
  previousPage?: string;
};

export default function TutorialPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<LocationState>();

  const steps = [
    { id: 1, stepName: "Myran", videoId: "kLLd09wd5GY", overlayText: t("What_is_Myran") },
    {
      id: 2,
      stepName: t("Myran-Analytics"),
      videoId: "EbrJO55lTto",
      overlayText: t("What_is_Analytics_portal"),
    },
    {
      id: 3,
      stepName: t("Create_Followups_Button"),
      videoId: "QAyh-CmRwjw",
      overlayText: t("How_to_create_a_followup"),
    },
    { id: 4, stepName: t("Conduct_Followup"), videoId: "ZViJdjO2xQc", overlayText: t("How_to_conduct_a_followup") },
  ];

  const handleBackClick = () => {
    if (location.state?.previousPage === "/follow-up-finish") history.push("/welcome");
    else history.goBack();
  };

  return (
    <VStack className="container" overflowY="auto" maxH={{ lg: "80vh", "2xl": "85vh" }}>
      <VStack w="100%" h="full" pos="relative">
        <Box pos="absolute" top="1" left="1" p={2} justifyContent="flex-start" alignContent="flex-start">
          <img
            src={LeftArrowInCircle}
            width="24px"
            height="24px"
            style={{ cursor: "pointer" }}
            onClick={() => handleBackClick()}
          />
        </Box>
        <VStack pt={{ base: 8, md: 12 }}>
          <Text className="heading">{t("Tutorial_Page_Title")}</Text>
          <Text className="heading-sub-text" pt="20px" pb="30px">
            {t("Tutorial_Page_Description_1")}
            <br />
            {t("Tutorial_Page_Description_2")}
          </Text>
        </VStack>
        <Box w="100%" display="flex" justifyContent="center" pt="20px">
          <Box w="100%" maxW="1200px" px={{ base: 4, md: 6 }}>
            <HStack pb="20px" align="center" w="100%" pl={{ md: 4, lg: 12, xl: 28 }}>
              <Box w="24px" border="1px #277AFF solid"></Box>
              <Text color="white" fontSize="20px">
                {t("Video_Tutorials")}
              </Text>
            </HStack>
            <Grid templateColumns="repeat(2, 1fr)" gap={6} pb="40px" pt="10px">
              {steps.map(step => (
                <VStack>
                  <Box
                    p="10px 20px"
                    mb="10px"
                    ml={{ md: 4, lg: 12, xl: 28 }}
                    bgColor="#2a0f74"
                    border="1px solid #2a0f74"
                    borderRadius="100px"
                    justifySelf="start"
                    alignSelf="start"
                  >
                    <HStack color="white">
                      <Text fontSize="14px">{step.stepName}</Text>
                    </HStack>
                  </Box>
                  <VideoModal videoId={step.videoId} overlayText={step.overlayText} />
                </VStack>
              ))}
            </Grid>
          </Box>
        </Box>
      </VStack>
    </VStack>
  );
}
